module.exports = __webpack_public_path__ + "img/mmi-home-hand-shake-connect.40c7b225.png";